var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#018FF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0902 23.8488V21.8103C16.0902 21.29 16.5151 20.8681 17.0393 20.8681H18.9554C19.2071 20.8681 19.4485 20.9674 19.6265 21.1441C19.8045 21.3208 19.9045 21.5604 19.9045 21.8103V23.8488C19.9029 24.0652 19.9884 24.2732 20.1419 24.4267C20.2954 24.5802 20.5044 24.6666 20.7223 24.6666H22.0295C22.6401 24.6682 23.2262 24.4285 23.6584 24.0005C24.0907 23.5724 24.3337 22.9912 24.3337 22.3851V16.5778C24.3336 16.0882 24.115 15.6238 23.7367 15.3097L19.2897 11.7838C18.5161 11.1656 17.4077 11.1856 16.6573 11.8312L12.3117 15.3097C11.9155 15.6146 11.6787 16.0803 11.667 16.5778V22.3792C11.667 23.6425 12.6986 24.6666 13.9711 24.6666H15.2485C15.7011 24.6666 16.069 24.3041 16.0723 23.8547L16.0902 23.8488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cbce4094.svg";
export { ForwardRef as ReactComponent };